import { defineStore } from "pinia";

export const useModalStore = defineStore("modal", {
  state: () => ({
    isOpen: false,
    component: null,
    props: {},
  }),

  actions: {
    // Mutations
    setIsOpen(isOpen) {
      this.isOpen = isOpen;
    },

    setComponent(component) {
      this.component = component;
    },

    setProps(props) {
      this.props = props;
    },

    open(payload) {
      this.setComponent(payload.component);
      this.setProps(payload.props || {});
      this.setIsOpen(true);
    },

    close() {
      this.setIsOpen(false);
      setTimeout(() => {
        this.setComponent(null);
        this.setProps({});
      }, 300);
    },
  },
});
